import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.116 4.116A1.25 1.25 0 0 1 4 3.75h4.599l1.777 2.666A.75.75 0 0 0 11 6.75h9A1.25 1.25 0 0 1 21.25 8v1.25a.75.75 0 0 0 1.5 0V8A2.75 2.75 0 0 0 20 5.25h-8.599L9.624 2.584A.75.75 0 0 0 9 2.25H4A2.75 2.75 0 0 0 1.25 5v14A2.75 2.75 0 0 0 4 21.75h5.222a.75.75 0 0 0 0-1.5H4A1.25 1.25 0 0 1 2.75 19V5c0-.332.132-.65.366-.884"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.53 13.47a.75.75 0 1 0-1.06 1.06l2.72 2.72H14a.75.75 0 0 0 0 1.5h6.19l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4a.75.75 0 0 0 0-1.06z"
    }, null, -1)
  ])))
}
export default { render: render }